import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { BroadcastService } from './services/broadcast-service/broadcast.service';
import { ApiService } from './services/mibp-api-services/_mibp-api-generated.service';
import { Subscription } from 'rxjs';
import { ClientIdService } from './services/clientid-service/clientid.service';
import { LogService, MibpHttpApi, MibpLogger, MibpResponsiveService } from './services';
import { GoogleTagManagerService } from './services/google-tag-manager-service/google-tag-manager.service';
import { filter } from 'rxjs/operators';
import { SwUpdate } from '@angular/service-worker';
import { MibpSessionService } from './services/mibp-session/mibp-session.service';
import { MibpDateTimeService } from './services/datetime/datetime.service';
import { DownloadedManualsService } from './services/downloaded-manuals/downloaded-manuals.service';
import { MibpSessionRevokedService } from './services/session-revoked/session-revoked.service';

import { DialogComponent } from 'root/shared/components/dialogs/dialog/dialog.component';
import { InlineEditingOverlayComponent } from 'root/components/inline-editing-overlay/inline-editing-overlay.component';
import { SessionTimeoutComponent } from 'root/components/session-timeout/session-timeout.component';
import { LoaderComponent } from 'root/shared/components/status/loader/loader.component';
import { MibpAppLoaderComponent } from 'root/components/app-loader/app-loader.component';
import { MibpToastHostComponent } from 'root/shared/components/status/toast/toast-host.component';
import { Customer } from 'root/mibp-openapi-gen/models';


@Component({
  selector: 'ecommerce-app',
    templateUrl: './ecommerce-app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DialogComponent, InlineEditingOverlayComponent, SessionTimeoutComponent, LoaderComponent, MibpAppLoaderComponent, MibpToastHostComponent]
})
export class EcommerceAppComponent implements OnInit {
  private broadcastService = inject(BroadcastService);
  private apiService = inject(ApiService);
  private clientIdService = inject(ClientIdService);
  private mibpSession = inject(MibpSessionService);
  private httpApiService = inject(MibpHttpApi);
  private downloadManualService = inject(DownloadedManualsService);
  private responsive = inject(MibpResponsiveService);
  private googleTagManagerService = inject(GoogleTagManagerService);
  private swUpdate = inject(SwUpdate);
  private sessionRevokedService = inject(MibpSessionRevokedService);
  private dateTimeService = inject(MibpDateTimeService);
  private log = inject(LogService).withPrefix('ecommerce-app.component');

  title = 'My Sandvik Customer Portal';
  userApiSubscription: Subscription;
  routerEventSub: Subscription;

  constructor() {
    this.clientIdService.getClientId(); // Just to make sure we have a ClientID
    this.responsive.begin();
    this.sessionRevokedService.startSubscription();
  }

  ngOnInit(): void {
    this.dateTimeService.testTimezoneSupport();
    this.downloadManualService.startListeningToEvents();

    if(this.swUpdate.isEnabled){
      this.swUpdate.versionUpdates.subscribe(() => {
        this.swUpdate.activateUpdate().then(() => location.reload());
      });
    }

    // When we receive this event we should request for updated session data
    // This could be when permissions or something is changed for the user
    this.apiService.EventHub.TriggerMibpSessionUpdate.pipe(filter(e => e !== null)).subscribe(() => {
      this.log.info(`Received TriggerMibpSessionUpdate event.`);
      this.mibpSession.reloadSessionFromBackend();
    });

    this.googleTagManagerService.setupGoogleTagManager();

    this.mibpLogErrors();
  }

  mibpLogErrors(): void {
    this.broadcastService.frontendError.subscribe(e => {
      if (e) {
        this.httpApiService.MibpLog.logFrontendError(e).then(() => {
          // No need to do anything here
        }, err => {
          // eslint-disable-next-line no-console
          console.warn('Could not log frontend error in MibpLog', err);
        });
      }
    });
  }
}
